import React from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from "@material-ui/core/ListItemIcon";
import {useTranslation} from "react-i18next";
import ListItemLink from "../../layouts/common/ListItemLink";
import {
    COMMUNICATOR_PAGE_PATH,
    EVENT_UPDATE_PAGE_PATH,
    SHIPMENT_TRACKING_PAGE_PATH
} from "../../layouts/navigation/Navigator";
import {AuthorizedContext} from "../../context/AuthorizedContext";
import {SHIPMENT_PERMISSIONS} from "../../constants/ShipmentPermissionsConstants";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flex: 1,
            justifyContent: "center"
        },
        list: {
            flex: 1,
            "& img": {
                height: 100
            },
            "& .MuiButtonBase-root": {justifyContent: "center"},
            "& .MuiListItemText-root": {
                flex: "none", padding: 10,
                textTransform: "uppercase",
                fontWeight: 500
            }
        }
    }),
);

const OverviewPageComponents = () => {
    const classes = useStyles();
    const {t} = useTranslation();
    const {hasPermission} = React.useContext(AuthorizedContext);


    return (<div className={classes.root}>
            <List className={classes.list}>
                <ListItemLink href={SHIPMENT_TRACKING_PAGE_PATH}>
                    <ListItemIcon><img src={"/assets/icons/location_pin_blue.png"}
                                       alt={"shipment-tracking"}/></ListItemIcon>
                    <ListItemText primary={t("menu.shipment-tracking")}/>
                </ListItemLink>


                <ListItemLink href={COMMUNICATOR_PAGE_PATH}>
                    <ListItemIcon><img src={"/assets/icons/user_message_blue.png"}
                                       alt={"communicator"}/></ListItemIcon>
                    <ListItemText primary={t("menu.communicator")}/>
                </ListItemLink>

                {hasPermission(SHIPMENT_PERMISSIONS.MILESTONE_LIST) &&
                <ListItemLink href={EVENT_UPDATE_PAGE_PATH}>
                    <ListItemIcon><img src={"/assets/icons/clock_forward_blue.png"}
                                       alt={"event-update"}/></ListItemIcon>
                    <ListItemText primary={t("menu.event-update")}/>
                </ListItemLink>
                }
            </List>
        </div>
    );
};

export default OverviewPageComponents;